import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  includedProductNames: [
    ...(filter.includedProductNames || []),
    ...Array.from(insights).map((insight) => insight.name)
  ]
})

const generateProductNameInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateProductNameInsightStrategy
